import * as types from './actionTypes';
import PrivateAPIResource from "../services/PrivateAPIResource";

export function loadCourseTypesSuccess(courseTypes) {
    return {type: types.LOAD_COURSE_TYPES_SUCCESS, courseTypes};
}

export function loadCourseTypes() {
    return function (dispatch) {
        return PrivateAPIResource.get('course-types').then(courseTypes => {
            dispatch(loadCourseTypesSuccess(courseTypes))
        }).catch(error => {
            throw  error;
        });
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/courseTypeActions.js